export const SkeletonTokenBadge = () => (
  <span
    className='ml-2 inline-flex h-[22px] w-[60px] items-center justify-center rounded-full px-2'
    aria-hidden='true'
  >
    <span className='bg-background-panel h-3 animate-pulse rounded-md' />
  </span>
);
